import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/dist/query';
import { persistStore } from 'redux-persist';

import { appMiddleware } from './middleware';
import { appReducer } from './reducer';

const configStore = () => {
  const store = configureStore({
    reducer: appReducer,

    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }).concat(appMiddleware),

    devTools: process.env.NODE_ENV !== 'production',
  });

  const persistor = persistStore(store);

  setupListeners(store.dispatch);

  return { store, persistor };
};

export const persistedStore = configStore();

export type RootState = ReturnType<typeof persistedStore.store.getState>;

export type AppDispatch = typeof persistedStore.store.dispatch;
